/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalDetailedCoverSheetDiagnosis
 */
export interface PalDetailedCoverSheetDiagnosis {
    /**
     * 
     */
    code: string;
    /**
     * 
     */
    description: string;
    /**
     * 
     */
    is_primary: boolean;
}

/**
 * Check if a given object implements the PalDetailedCoverSheetDiagnosis interface.
 */
export function instanceOfPalDetailedCoverSheetDiagnosis(value: object): value is PalDetailedCoverSheetDiagnosis {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('is_primary' in value) || value['is_primary'] === undefined) return false;
    return true;
}

export function PalDetailedCoverSheetDiagnosisFromJSON(json: any): PalDetailedCoverSheetDiagnosis {
    return PalDetailedCoverSheetDiagnosisFromJSONTyped(json, false);
}

export function PalDetailedCoverSheetDiagnosisFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalDetailedCoverSheetDiagnosis {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'description': json['description'],
        'is_primary': json['is_primary'],
    };
}

export function PalDetailedCoverSheetDiagnosisToJSON(json: any): PalDetailedCoverSheetDiagnosis {
    return PalDetailedCoverSheetDiagnosisToJSONTyped(json, false);
}

export function PalDetailedCoverSheetDiagnosisToJSONTyped(value?: PalDetailedCoverSheetDiagnosis | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'description': value['description'],
        'is_primary': value['is_primary'],
    };
}

